module.exports = __webpack_public_path__ + "img/team-sharedfile.fd43754a.svg";